import { defineComponent, onBeforeUnmount, onMounted, ref, Teleport } from "vue";
import styles from "./Header.module.less";
import { MenuFoldOutlined, MenuUnfoldOutlined, SearchOutlined, CompressOutlined, ExpandOutlined, UserOutlined, DownOutlined, LoadingOutlined, ReloadOutlined } from "@ant-design/icons-vue";
import Breadcrumb from "./Breadcrumb/Breadcrumb";
import screenfull from 'screenfull';
import { message } from "ant-design-vue";
import MenuSearch from "./MenuSearch/MenuSearch";
import { useStore as useUserStore } from "@/store/user";
import { useRoute, useRouter } from "vue-router";
import { useStore as useTagsStore } from "@/store/tags";
export default defineComponent({
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:isCollapsed'],
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const tagsStore = useTagsStore();
    const userStore = useUserStore();
    // 左侧
    const Left = () => (
      <div class={styles.left}>
        <div class={styles['collapsed-box']} onClick={() => { emit("update:isCollapsed", !props.isCollapsed) }}>
          <MenuUnfoldOutlined v-show={props.isCollapsed} />
          <MenuFoldOutlined v-show={!props.isCollapsed} />
        </div>
        <Breadcrumb />
      </div>
    )

    const menuSearchVisible = ref(false);

    // 打开菜单搜索
    const toSearchMenu = () => {
      menuSearchVisible.value = true;
    }

    // 是否全屏
    const isScreenFull = ref(false);
    // 切换全屏状态
    const isScreenFullChange = () => {
      isScreenFull.value = screenfull.isFullscreen;
    }

    onMounted(() => {
      if (screenfull.isEnabled) {
        screenfull.on('change', isScreenFullChange);
      }
    })

    onBeforeUnmount(() => {
      if (screenfull.isEnabled) {
        screenfull.off('change', isScreenFullChange);
      }
    })

    // 全屏切换
    const setScreenfull = () => {
      if (!screenfull.isEnabled) {
        message.error('浏览器不支持全屏!');
        return;
      }
      screenfull.toggle();
    }

    // 头像hover小弹窗
    const avatar_menu = [
      {
        label: '个人中心',
        click: () => {

        },
      },
      {
        label: '退出登录',
        click: async () => {
          await userStore.logout();
          let redirect = route.fullPath;
          router.push(`/login?redirect=${redirect}`);
        },
      },
    ];

    // 刷新中
    const refreshing = ref(false);
    // 刷新main部分页面
    const refreshPage = () => {
      refreshing.value = true;
      tagsStore.refresh(route, () => {
        refreshing.value = false;
      })
    }

    // 右侧
    const Right = () => (
      <div class={styles.right}>
        <div class={styles.icon} title="菜单搜索" onClick={() => { toSearchMenu() }}>
          <SearchOutlined />
        </div>
        <div class={styles.icon} title={isScreenFull.value ? '退出全屏' : '全屏'} onClick={() => { setScreenfull() }}>
          {
            isScreenFull.value ? <CompressOutlined /> : <ExpandOutlined />
          }
        </div>
        <div class={styles.icon} title="刷新" onClick={() => { refreshPage() }}>
          {
            refreshing.value ? <LoadingOutlined /> : <ReloadOutlined />
          }
        </div>
        <a-dropdown v-slots={{
          overlay: () => {
            return (
              <a-menu class={styles.dropdown}>
                {
                  avatar_menu.map(x => (
                    <a-menu-item key={x.label} onClick={() => x.click()}>{x.label}</a-menu-item>
                  ))
                }
              </a-menu>
            )
          }
        }}>
          <div class={styles.avatar}>
            <a-avatar size={24} v-slots={{
              icon: () => {
                return (
                  userStore.info.avatar ? <img src={userStore.info.avatar} /> : <UserOutlined />
                )
              }
            }}>
            </a-avatar>
            <span>{userStore.info.name}</span>
            <DownOutlined class={styles.downIcon} />
          </div>
        </a-dropdown>
      </div>
    )
    return () => (
      <>
        <div class={styles.header}>
          <Left />
          <Right />
        </div>
        {/* 菜单搜索 */}
        <Teleport to="body">
          {
            menuSearchVisible.value && <div class={styles.menuSearch} onClick={() => { menuSearchVisible.value = false }}>
              <div class={styles.menuSearchContainer} onClick={(e: any) => { e.stopPropagation() }}>
                <MenuSearch v-model={[menuSearchVisible.value, 'menuSearchVisible']} />
              </div>
            </div>
          }
        </Teleport>
      </>
    )
  }
})